// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

// This API needs to be in sync with /Users/matv/stripe/pay-server/frontend/sail-next/packages/docs/src/markdoc/Demo.markdoc.ts
export const TailorExample: MarkdocTagRegistration = {
  tag: 'tailor-example',
  component: 'TailorExample',
  attributes: {
    component: {
      type: String,
      description: 'Tailor UI Toolkit component',
      required: true,
    },
    example: {
      type: String,
      description: 'Story for the Tailor UI Toolkit component',
      required: true,
    },
    hideSourceCode: {
      type: Boolean,
      description: 'Hide the source code. Useful for demos',
      default: false,
    },
    showBackground: {
      type: Boolean,
      description: 'Show the background of the component',
      default: false,
    },
    fill: {
      type: Boolean,
      description: 'Fill the container',
      default: true,
    },
  },
};
